import axios from "axios";
// import store from "@/store";
import router from "@/router";

// create an axios instance
const service = axios.create({
  baseURL: `${process.env.VUE_APP_USER_API}api/`, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response;

    if (res.status !== 200 && res.status !== 201 && res.status !== 204) {
      console.log(res.status);
      console.log("Error");
      console.log(res);
      return Promise.reject(new Error("Error"));
    } else {
      return res;
    }
  },
  (error) => {
    if (error.response.status === 401) {
      // store.dispatch("user/logout");
      router.push("/login");
      return Promise.reject(error);
    }
    console.log("err" + error); // for debug
    console.log("err" + error.message);
    return Promise.reject(error);
  }
);

export default service;
